/**
 * Api Documentation
 * Api Documentation
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { LoginRequestDto } from '../model/loginRequestDto';
import { LoginResponseDto } from '../model/loginResponseDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class AuthenticationControllerService {

    protected basePath = 'https://skillx-dev.molaris.local:8888';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * login
     * 
     * @param loginRequestDto loginRequestDto
     * @param xSkillXInstance X-SkillX-Instance
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public loginUsingPOST(loginRequestDto: LoginRequestDto, xSkillXInstance?: string, observe?: 'body', reportProgress?: boolean): Observable<LoginResponseDto>;
    public loginUsingPOST(loginRequestDto: LoginRequestDto, xSkillXInstance?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<LoginResponseDto>>;
    public loginUsingPOST(loginRequestDto: LoginRequestDto, xSkillXInstance?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<LoginResponseDto>>;
    public loginUsingPOST(loginRequestDto: LoginRequestDto, xSkillXInstance?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (loginRequestDto === null || loginRequestDto === undefined) {
            throw new Error('Required parameter loginRequestDto was null or undefined when calling loginUsingPOST.');
        }


        let headers = this.defaultHeaders;
        if (xSkillXInstance !== undefined && xSkillXInstance !== null) {
            headers = headers.set('X-SkillX-Instance', String(xSkillXInstance));
        }

        // authentication (JWT) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<LoginResponseDto>(`${this.basePath}/login`,
            loginRequestDto,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
